<script setup lang="ts">
interface IconArrowRightProps {
  color?: string
}

defineProps({
  color: null
})
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 17.5L14.5 12L9 6.5"
      :stroke="color || '#000099'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
